import { useState } from "react";
import { Navigate } from "react-router-dom";
import { LoaderCircle } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Logo } from "@/components/site/Logo";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <form onSubmit={submit} className="w-full max-w-sm space-y-5 rounded-md border border-white/10 bg-[#121212] p-8" data-testid="admin-login-form">
        <Logo />
        <h1 className="h-display text-4xl text-white">Staff login</h1>
        <div className="space-y-1.5"><Label>Email</Label><Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-11 bg-black/40" data-testid="login-email-input" /></div>
        <div className="space-y-1.5"><Label>Password</Label><Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="h-11 bg-black/40" data-testid="login-password-input" /></div>
        {error && <p className="text-sm text-red-400" data-testid="login-error">{error}</p>}
        <button type="submit" disabled={busy} className="btn-gold w-full" data-testid="login-submit-button">
          {busy && <LoaderCircle className="h-5 w-5 animate-spin" />} Log in
        </button>
      </form>
    </div>
  );
}
